<p-toast position="top-center" [baseZIndex]="5000" [key]="this.key" [preventOpenDuplicates]="true" modal="false">
    <ng-template let-message pTemplate="message">
        <div class="toastContent tst-{{message.severity}}" pRipple>
            <ng-container *ngIf="!template">
                <span class="p-toast-message-icon accelicons " [ngClass]="{'accelicons-ellipsis-small': message.severity === 'info', 'accelicons-alert2': message.severity === 'warn',
                    'accelicons-exclamation-circle-small': message.severity === 'error', 'accelicons-checkmark-small' :message.severity === 'success'}"></span>                  
                <div class="p-toast-message-text p-ml-3">
                    <div class="p-toast-summary" [aria-label]="message.summary">{{message.summary}}</div>
                    <div class="p-toast-detail" [aria-label]="message.detail">{{message.detail}}</div>
                </div>
            </ng-container>
            <ng-container *ngTemplateOutlet="template; context: {$implicit: message}"></ng-container>
            <button type="button" class="p-message-close p-link" (click)="onCloseIconClick($event)" (keydown.enter)="onCloseIconClick($event)" 
                i18n-aria-label="Dismiss | Dismiss Alert Button" aria-label="Dismiss" pRipple>
                <span class="custom p-toast-icon-close-icon pi pi-times"></span>
            </button>
        </div>
    </ng-template> 
</p-toast>  
